import React, { Component } from "react";
import { connect } from "react-redux";
import PriceAlertModal from "./PriceAlertModal";
import { $, outputFilteredFlights, mergeFlights, decorateFlight } from "../../shared/utils";
import { getNewPrices,  } from "../../actions";
import { getFlightCheckoutDetails } from "../../shared/requests-api";

class PriceAlert extends Component {
	constructor(props) {
		super(props);
		this.state = {
			priceModalOpen: false,
			city: props.city,
			canOpenModal: props.canOpenModal
		};

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		$("body").classList.add("tingle-enabled");
		$(".btn-price-alert-modal").classList.add("disabled");
		$(".btn-price-alert-modal").disabled = true;

		const { flights, selectedFilters, searchParams, searchStatus: { progress, searchId } } = this.props;

		if (progress < 100) {
			return;
		}

		this.setState({ value: undefined });
		
		const flightsOutbound = outputFilteredFlights(
			flights.outbound, selectedFilters.outbound,
			{ column: "maxSaleTotal", order: "ORDER_ASC" }
		).filter(flight => flight.otaAvailableIn === "maxmilhas" || flight.otaAvailableIn === "both");

		if (flightsOutbound.length === 0) {
			return;
		}

		this.setState({ priceModalOpen: true });

		if (searchParams.inboundDate) {
			getNewPrices(flightsOutbound[0].airlineTarget, flightsOutbound[0], searchId).then(updated => {
				if (updated.status === 200) {
					const updatedFlights = mergeFlights(flights.inbound, updated.data.inbound.map(decorateFlight), flightsOutbound[0].airlineTarget);
					const flightsInbound = outputFilteredFlights(
						updatedFlights, selectedFilters.inbound,
						{ column: "maxSaleTotal", order: "ORDER_ASC" }
					).filter(flight => flight.otaAvailableIn === "maxmilhas" || flight.otaAvailableIn === "both");

					if (flightsInbound.length > 0) {
						this.callFlightDetails([flightsOutbound[0], flightsInbound[0]]);
					}
				}
			});
		} else {
			this.callFlightDetails([flightsOutbound[0]]);
		}
	}

	callFlightDetails(flights) {
		const { searchStatus: { searchId } } = this.props;

		getFlightCheckoutDetails(flights.map(flight => flight.id), searchId).then(result => {
			if (result.status === 200) {
				const total = result.data.flights.reduce((value, flight) => {
					return flight.pricing[flight.pricing.mmBestPriceAt].saleTotal + value;
				}, 0);

				this.setState({
					priceModalOpen: true,
					value: total
				});

				$(".btn-price-alert-modal").classList.remove("disabled");
				$(".btn-price-alert-modal").disabled = false;
			}
		});
	}

	closeModal() {
		const { onClose } = this.props;
		$("body").classList.remove("tingle-enabled");

		this.setState({
			priceModalOpen: false,
			canOpenModal: false,
		});
		onClose();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.city === undefined && this.props.city !== undefined) {
			this.setState({ city: this.props.city, canOpenModal: this.props.canOpenModal });
		}
	}

	componentWillReceiveProps(nextProps) {
		const { canOpenModal } = nextProps;
		const { canOpenModal: canOpenModalState } = this.state;

		if (canOpenModalState != canOpenModal) {
			this.setState({ canOpenModal })
			if (canOpenModal) {
				this.openModal()
			} else {
				this.closeModal();
			}
		}
	}

	render() {
		return (			
			<div className={`tingle-modal tingle-modal--price-alert ${this.state.priceModalOpen ? "tingle-modal--visible tingle-modal--noOverlayClose tingle-modal--overflow" : "hide"}`}>
				{/* <button className="tingle-modal__close" onClick={() => this.closeModal()}>
					<span className="tingle-modal__closeIcon">×</span>
				</button> */}
				<PriceAlertModal
					closeModal={this.closeModal}
					value={this.state.value}
					city={this.state.city}
					canOpenModal={this.state.canOpenModal}
				/>
			</div>				
		);
	}
}

const mapStateToProps = state => ({
	flights: state.flights,
	searchParams: state.searchParams.params,
	selectedFilters: state.selectedFilters,
	searchStatus: state.searchStatus
});

export default connect(mapStateToProps)(PriceAlert);
